// Tag computation primitives — pure functions

import { hash, concat } from './crypto.js';
import { type Result, ok, err } from './types.js';

/** Compute a room tag: Hash(roomId || nonce || head). */
export const computeRoomTag = (roomId: Uint8Array, nonce: Uint8Array, head: Uint8Array): Uint8Array =>
  hash(concat(roomId, nonce, head));

/** Compute a sender tag: Hash(publicKey || nonce). */
export const computeSenderTag = (publicKey: Uint8Array, nonce: Uint8Array): Uint8Array =>
  hash(concat(publicKey, nonce));

/** Given a list of member public keys, find which one matches the sender tag. */
export const findSender = (
  members: ReadonlyArray<Uint8Array>,
  senderTag: Uint8Array,
  nonce: Uint8Array,
): Result<Uint8Array, string> => {
  const found = members.find((pub) => {
    const candidateTag = computeSenderTag(pub, nonce);
    return candidateTag.length === senderTag.length &&
      candidateTag.every((byte, i) => byte === senderTag[i]);
  });
  return found !== undefined
    ? ok(found)
    : err('No matching sender found among room members');
};
